var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Estás siendo redirigido a la página de Navision")])}
var staticRenderFns = []

export { render, staticRenderFns }